import React from 'react';
import { Tag } from 'antd';
import { getTranslatedString } from 'helpers/i18n';
import { colors } from '@yuhuinc/ui-library';

export const IncentiveStatusTag = (incentive) => {
  if (!incentive?.status || !validIncentiveStatus.includes(incentive?.status)) return null;

  return (
    <Tag color={colors.TAG_STATUS_COLORS.incentive[incentive.status]}>
      {getTranslatedString(`landlordPortal.incentives.${incentive.status}`)}
    </Tag>
  );
};

export const incentiveStatus = {
  draft: 'draft',
  published: 'published',
  archived: 'archived',
};

export const validIncentiveStatus = Object.values(incentiveStatus);
